import { render, staticRenderFns } from "./main-content-portal-card.vue?vue&type=template&id=55ff9d83&"
import script from "./main-content-portal-card.vue?vue&type=script&lang=ts&"
export * from "./main-content-portal-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports